'use client';

import type { ReactNode } from 'react';
import { useAuth } from '@/infrastructure/auth';
import { isNovuEnabled } from '../novu-config';
import { useNotificationRealtimeProcessor } from './useNotificationRealtimeProcessor';

// Side-effect imports: register all module strategies.
// Add new modules here as they implement realtime invalidation.
import '@/features/i18n/notifications';

/**
 * Inner component that activates the WebSocket listener.
 * Separated so `useNovu()` is only called when NovuProvider is active.
 */
function RealtimeProcessorMount() {
  useNotificationRealtimeProcessor();
  return null;
}

interface NotificationRealtimeProviderProps {
  children: ReactNode;
}

/**
 * Auth-guarded provider that enables real-time React Query
 * cache invalidation driven by incoming Novu notifications.
 *
 * Must be placed inside `NovuClientProvider`.
 */
export function NotificationRealtimeProvider({ children }: NotificationRealtimeProviderProps) {
  const { isAuthenticated } = useAuth();

  return (
    <>
      {isAuthenticated && isNovuEnabled() && <RealtimeProcessorMount />}
      {children}
    </>
  );
}
